import PropTypes from 'prop-types'
import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { ID_PERFIL_ADMIN_EBP } from '../../constants/perfiles'
import { LoginContext } from '../context/loginContext'

const RUTA_REDIRECCION = '/Publicaciones'

const RutaProtegidaPorPerfil = ({ children, perfilesPermitidos }) => {
  const { loginDataContext } = useContext(LoginContext)
  const idPerfil = loginDataContext.idPerfil
  const habilitado = idPerfil === ID_PERFIL_ADMIN_EBP || perfilesPermitidos.includes(idPerfil)

  if (!habilitado) {
    return <Navigate to={RUTA_REDIRECCION} replace />
  }

  return children
}

RutaProtegidaPorPerfil.propTypes = {
  children: PropTypes.node.isRequired,
  perfilesPermitidos: PropTypes.arrayOf(PropTypes.number).isRequired
}

export default RutaProtegidaPorPerfil
